import { useCallback } from 'react'

import { IconFCType } from '@ui/icons/types'

import { useWindowResize } from '@utils/domUtils'

import { TickmillProductType } from '@model/TickmillProductType'

export const MenuVariant = {
  ACTION: 'action',
  NAVIGATION: 'navigation',
} as const

export type MenuVariantType = (typeof MenuVariant)[keyof typeof MenuVariant]
export interface MenuSection {
  id: string
  label: string
  path?: string
  icon?: IconFCType
  children?: MenuSection[]
  onClick?: () => void
  alertActive?: boolean
  infoClick?: () => void
  products?: TickmillProductType[]
  condition?: boolean
  isSelected?: boolean
  rightIcon?: IconFCType
  screenChildren?: MenuSection[]
  highlighted?: boolean
  variant?: MenuVariantType
  tourTarget?: string
  closeOnSelect?: boolean
}

export const filterMenuSections = (
  sections: MenuSection[],
  product: TickmillProductType
): MenuSection[] =>
  sections
    .filter((section) => section.condition !== false)
    .filter((section) => (section.products ? section.products.includes(product) : true))
    .map((section) =>
      section.children
        ? { ...section, children: filterMenuSections(section.children, product) }
        : section
    )

export const useWithMobileIcon = () => {
  const isMobile = useWindowResize()
  return useCallback((icon: IconFCType) => (isMobile ? icon : undefined), [isMobile])
}
